import classNames from "classnames";
import React, { useEffect, useRef } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useIsBeta } from "context/betaContext";
import { useAuthenticatedUser } from "hooks/useAuthenticatedUser";
import { useCompany } from "hooks/useCompany";
import { setGainsightUserScope } from "utils/gainsight";
import { setLogrocketUserScope } from "utils/logrocket";
import { PageRouter } from "./components/PageRouter";
import { SideNav } from "./components/SideNav";
import { SystemOverlays } from "./components/SystemOverlays";
import { TopNav } from "./components/TopNav";
import { useStyles } from "./styles";
import { DefaultErrorBoundary } from "../ErrorBoundary";

export const Layout: FC<{ withoutSideNav?: boolean; topNav?: React.ReactNode }> = ({
	className,
	withoutSideNav,
	topNav
}) => {
	const classes = useStyles();
	const company = useCompany();
	const { user, loginDetails } = useAuthenticatedUser();
	const currentUserId = useRef<string>();
	const isBeta = useIsBeta();

	useEffect(() => {
		if (user && company && user.id !== currentUserId.current) {
			setGainsightUserScope(user, company, loginDetails);
			setLogrocketUserScope(user);
			currentUserId.current = user.id;
		}
	}, [user, company, loginDetails]);

	return (
		<div className={classNames(classes.columnLayout, className)}>
			{topNav !== undefined ? topNav : <TopNav />}
			<SystemOverlays />
			<div className={classNames(classes.rowLayout, className)}>
				{!withoutSideNav && (!isBeta || user?.isAdmin) && <SideNav className={classes.sideNav} />}
				<ErrorBoundary FallbackComponent={DefaultErrorBoundary}>
					<div className={classes.pages}>{user && <PageRouter user={user} />}</div>
				</ErrorBoundary>
			</div>
		</div>
	);
};
